// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/.pnpm/registry.npmmirror.com+css-loader@3.6.0_webpack@4.47.0/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".user_detail_page .header[data-v-7110106b] {\n  height: 50px;\n  font-size: 24px;\n  font-weight: 500;\n  border-bottom: 1px solid #eee;\n  margin-left: 5px;\n}\n.user_detail_page .user_detail_msg[data-v-7110106b] {\n  height: 50px;\n  line-height: 50px;\n}\n.user_detail_page .table_title[data-v-7110106b] {\n  font-weight: 700;\n  margin-top: 50px;\n  padding-left: 50px;\n}\n", ""]);
// Exports
module.exports = exports;
